/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { head } from 'lodash';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { AccountPaymentTable } from 'web-ui-components/lib/finance/accounts';
import { Grid } from 'web-ui-components/lib/layout/grids';
import withContent from '../../containers/withContent';
import paymentDetailsContent, {
	contentPropTypes,
} from '../../components/PaymentDetails/batch/BatchPaymentDetails.content';
import { formatDate, formatLongDateTime } from '../../utils/dateUtils';
import { verificationPropTypes } from '../../states/payments/propTypes';
import { formatAmount } from '../../utils/numberUtils';
import { showAccountDetails, showAmount, getFormattedReference } from '../../utils/paymentsUtils';

export const ViewBatchPaymentDetailsForOtherUsers = ({ content, payment, goBack }) => {
	const {
		title,
		fromLabel,
		toLabel,
		amountLabel,
		refLabel,
		paymentDateLabel,
		createdByLabel,
		createdOnLabel,
		transactions,
		totalAmountLabel,
		back,
	} = content;

	const { batch, start_date, amount } = payment;
	const { created_by, last_updated_on } = head(payment.batch);
	const batchHeader = [
		{ type: 'account', label: fromLabel },
		{ type: 'account', label: toLabel },
		{ type: 'currency', label: amountLabel },
		{ type: 'iban', label: refLabel },
	];

	const getMyDataForFileUpload = (batch) =>
		batch.map((payment, index) => [
			showAccountDetails(payment.from_account, index),
			showAccountDetails(payment.to_account, index),
			showAmount(payment.amount.value, index),
			getFormattedReference(payment.reference, index),
		]);

	const rows = getMyDataForFileUpload(payment.batch).flat();

	const otherUsersBatchPaymentData = [
		{ headerText: fromLabel, cellText: 'File upload summary' },
		{ headerText: paymentDateLabel, cellText: formatDate(start_date) },
		{ headerText: totalAmountLabel, cellText: formatAmount(amount.value) },
		{ headerText: transactions, cellText: batch.length },
		{ headerText: createdByLabel, cellText: created_by },
		{ ...(last_updated_on ? { headerText: createdOnLabel, cellText: formatLongDateTime(last_updated_on) } : []) },
	];

	return (
		<div>
			<SectionHeading>{title}</SectionHeading>
			<Grid.TwoThirds>
				<VerticalReviewTable data={otherUsersBatchPaymentData} />
			</Grid.TwoThirds>
			<AccountPaymentTable headerData={batchHeader} tableData={rows} />
			<Button id="button-back" display="secondary" width="flush" onClick={goBack}>
				{back}
			</Button>
		</div>
	);
};

ViewBatchPaymentDetailsForOtherUsers.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
	goBack: PropTypes.func,
};

const contentWrapper = withContent({ content: paymentDetailsContent });
export default connect()(contentWrapper(ViewBatchPaymentDetailsForOtherUsers));
export const ConnectWrapper = connect()(ViewBatchPaymentDetailsForOtherUsers);
